import './App.css';
import React from 'react'
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import EmailVerify from './Components/Pages/Auth/EmailVerify'
import ForgotPassword from './Components/Pages/Auth/ForgotPword'
import PasswordSuccess from './Components/Pages/Auth/PwordResetSucces'
import EmailVerifyComplete from './Components/Pages/Auth/EmailVerifyComplete'
import Register from './Components/Pages/Auth/Register'
import VerifyPayment from './Components/Pages/verifyPayment'
import VerifyCreditUserPayment from './Components/Pages/verifyCreditUserPayment'
import Login from './Components/Pages/Auth/Login';
import Dashboard from './Components/user/Dashboard';
import Dashboards from './Components/admin/Dashboard';
import Shipments from './Components/user/Shipments';
import AdminShipments from './Components/admin/Shipments';
import CreditCustomer from './Components/admin/CreditCustomer';
import ManageCreditCustomerRates from './Components/admin/ManageCreditCustomerRate';
import EditCreditCustomer from './Components/admin/EditCreditCustomer';
import ChangePassword from './Components/Pages/Auth/ChangePassword';
import CalculateRate from './Components/user/CalculateRate';
import CalculateAdminRate from './Components/admin/CalculateRate';
import Tracking from './Components/user/Tracking';
import AdminTracking from './Components/admin/Tracking';
import Settings from './Components/user/Settings';
import PaymentConfirmation from './Components/admin/PaymentConfirmation';
import PaymentProofs from './Components/admin/PaymentProofs';
import SubmitPaymentProof from './Components/admin/SubmitPaymentProof';
import PaymentApproval from './Components/admin/PaymentApproval';
import LegacyMigration from './Components/admin/LegacyMigration';
import FleetRiders from './Components/fleet/FleetRiders';
import AdminDashboard from './Components/admin/AdminDashboard';
import ManageInvoice from './Components/admin/ManageInvoice';
import ManageExpense from './Components/admin/ManageExpense';
import ManageAudit from './Components/admin/ManageAudit';
import Manifest from './Components/admin/Manifest';
import RunwayManifest from './Components/admin/RunwayManifest';
import ManageRider from './Components/admin/ManageRiders';
import ManageStaffs from './Components/admin/ManageStaffs';
import ManageBranch from './Components/admin/ManageBranch';
import ManageRates from './Components/admin/ManageRates';
import UsersList from './Components/admin/UsersList';
import EditShipment from './Components/admin/EditShipment';
import EditUserShipment from './Components/user/EditShipment';
import Home from './Components/Pages/Home';
import About from './Components/Pages/About';
import Services from './Components/Pages/Services';
import TrackingPage from './Components/Pages/TrackingPage';
import Blog from './Components/Pages/Blog';
import UsaToNigeria from './Components/Pages/BlogDetails/UsaToNigeria';
import UkToNigeria from './Components/Pages/BlogDetails/UkToNigeria';
import ExpenseVoucher from './Components/admin/ExpenseVoucher';
import EditExpenseVoucher from './Components/admin/EditExpenseVoucher';
import StaffLogin from './Components/Pages/Auth/StaffLogin';
import ContactUs from './Components/Pages/ContactUs';
import RiderRegistration from './Components/Pages/Auth/RiderRegistration';
import RiderApplications from './Components/admin/RiderApplications';
import RiderWallet from './Components/rider/RiderWallet';
import FraudDashboard from './Components/admin/FraudDashboard';
import FineSettings from "./Components/admin/FineSettings";
import AdminWithdrawals from './Components/admin/AdminWithdrawals';
import AdminWallets from './Components/admin/AdminWallets';
import AdminWalletDetail from './Components/admin/AdminWalletDetail';
import BecomeARider from './Components/Pages/BecomeARider';
import FleetRegistration from './Components/Pages/Auth/FleetRegistration';
import DeliveryPayments from './Components/admin/DeliveryPayments';
import PendingFines from './Components/admin/PendingFines';
import AnalyticsDashboard from './Components/admin/AnalyticsDashboard';
import Reimbursements from './Components/admin/Reimbursements';
import RiderLoans from './Components/admin/RiderLoans';
import CustomDutyPayments from './Components/admin/CustomDutyPayments';
import BillingZoneSettings from './Components/admin/billing/BillingZoneSettings';
import ClientInvoices from './Components/admin/billing/ClientInvoices';
import FfdxFeedLog from './Components/admin/ffdx/FfdxFeedLog';
import LoanWallet from './Components/admin/LoanWallet';
import AutoAttemptedDeliveries from './Components/admin/AutoAttemptedDeliveries';
import VoucherSettings from './Components/admin/VoucherSettings';

// ── Partner / customer API gateway (NIPOST integration) ──────
import ApiGatewayDashboard from './Components/admin/apiGateway/ApiGatewayDashboard';
import PartnerManagement from './Components/admin/apiGateway/PartnerManagement';
import PartnerDetails from './Components/admin/apiGateway/PartnerDetails';
import ApiKeyManagement from './Components/admin/apiGateway/ApiKeyManagement';
import ApiGatewayAnalytics from './Components/admin/apiGateway/AnalyticsDashboard';
import SystemHealth from './Components/admin/apiGateway/SystemHealth';
import PortalAccountManagement from './Components/admin/apiGateway/PortalAccountManagement';
import PortalAccountDetails from './Components/admin/apiGateway/PortalAccountDetails';
import InvoiceManagement from './Components/admin/apiGateway/InvoiceManagement';
import PartnerBilling from './Components/admin/apiGateway/PartnerBilling';
import ApiGatewayManual from './Components/admin/apiGateway/ApiGatewayManual';
import ApiAccessRegister from './Components/Pages/Auth/ApiAccessRegister';
import ApiAccessLogin from './Components/Pages/Auth/ApiAccessLogin';
import PortalDashboard from './Components/portal/PortalDashboard';
import PortalApiKeys from './Components/portal/PortalApiKeys';
import PortalUsage from './Components/portal/PortalUsage';
import PortalWallet from './Components/portal/PortalWallet';
import PortalWebhooks from './Components/portal/PortalWebhooks';
import PortalInvoices from './Components/portal/PortalInvoices';
import PortalDocs from './Components/portal/PortalDocs';
import PortalSettings from './Components/portal/PortalSettings';
import PortalPending from './Components/portal/PortalPending';
import PortalRejected from './Components/portal/PortalRejected';

// ── Protected Route Component ────────────────────────────────
function ProtectedRoute({ permission, children }: { permission: string | string[]; children: React.ReactNode }) {
  const userLoginData = useSelector((state: any) => state.data.login.value);
  const userRole = userLoginData?.data?.role;
  const userPermissions: string[] = userLoginData?.data?.permissions
    ? JSON.parse(userLoginData.data.permissions)
    : [];

  // Not logged in → go to login
  if (!userLoginData?.token) {
    return <Navigate to="/staff-login" replace />;
  }

  // Admin always has access
  if (userRole === 'admin') return <>{children}</>;

  // Check permissions
  const requiredPermissions = Array.isArray(permission) ? permission : [permission];
  const hasPermission = requiredPermissions.some(p => {
    if (p === 'role:fleet') return userRole === 'fleet';
    if (p === 'role:rider') return userRole === 'rider';
    if (p === 'role:driver') return userRole === 'driver';
    if (p === 'authenticated') return true; // already checked above
    return userPermissions.includes(p);
  });

  if (!hasPermission) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <div>
      <Routes>
        <Route path='*' element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/rider-registration" element={<RiderRegistration />} />
        <Route path="/fleet-registration" element={<FleetRegistration />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/tracking-page" element={<TrackingPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/staff-login" element={<StaffLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-payment" element={<VerifyPayment />} />
        <Route path="/verify-credit-user-payment" element={<VerifyCreditUserPayment />} />
        <Route path="/email-verify" element={<EmailVerify />} />
        <Route path="/analytics" element={<AnalyticsDashboard />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/password-success" element={<PasswordSuccess />} />
        <Route path="/email-verify/:email" element={<EmailVerifyComplete />} />
        <Route path="/become-a-rider" element={<BecomeARider />} />

        {/* Blog Details */}
        <Route path="/how-to-ship-goods-from-nigeria-to-usa" element={<UsaToNigeria />} />
        <Route path="/how-to-export-foodstuffs-from-nigeria-to-uk" element={<UkToNigeria />} />

        {/* User */}
        <Route path="/user-dashboard" element={<Dashboard />} />
        <Route path="/shipments" element={<Shipments />} />
        <Route path="/edit-user-shipment/:id" element={<EditUserShipment />} />
        <Route path="/calculate-rate" element={<CalculateRate />} />
        <Route path="/tracking" element={<Tracking />} />
        <Route path="/settings" element={<Settings />} />

        {/* Rider Wallet — riders without fleet, fleet agents, drivers without fleet */}
        <Route path="/rider/wallet" element={
          <ProtectedRoute permission={['role:rider', 'role:fleet', 'role:driver']}>
            <RiderWallet />
          </ProtectedRoute>
        } />

        <Route path="/admin/pending-fines" element={
          <ProtectedRoute permission="can_manage_fine_settings">
            <PendingFines />
          </ProtectedRoute>
        } />

        {/* Auto-Attempted Deliveries — read-only SLA report for customer service */}
        <Route path="/admin/auto-attempted-deliveries" element={
          <ProtectedRoute permission="can_view_auto_attempted">
            <AutoAttemptedDeliveries />
          </ProtectedRoute>
        } />

        {/* Admin — open to all authenticated staff (sidebar handles visibility) */}
        <Route path="/admin/admin-dashboard" element={
          <ProtectedRoute permission={['can_view_admin_stat', 'authenticated']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute permission="authenticated">
            <Dashboards />
          </ProtectedRoute>
        } />

        {/* Shipments */}
        <Route path="/admin/shipments" element={
          <ProtectedRoute permission={['can_manage_shipment', 'role:rider']}>
            <AdminShipments />
          </ProtectedRoute>
        } />
        <Route path="/admin/edit-shipment/:id" element={
          <ProtectedRoute permission="can_manage_shipment">
            <EditShipment />
          </ProtectedRoute>
        } />

        {/* Users */}
        <Route path="/admin/users" element={
          <ProtectedRoute permission="can_view_users">
            <UsersList />
          </ProtectedRoute>
        } />

        {/* Credit Customers */}
        <Route path="/admin/credit-customers" element={
          <ProtectedRoute permission="can_manage_credit_customers">
            <ManageCreditCustomerRates />
          </ProtectedRoute>
        } />
        <Route path="/admin/view-credit-customers/:id" element={
          <ProtectedRoute permission="can_manage_credit_customers">
            <EditCreditCustomer />
          </ProtectedRoute>
        } />

        {/* Expense Voucher */}
        <Route path="/admin/expense-voucher" element={
          <ProtectedRoute permission="can_create_expense_voucher">
            <ExpenseVoucher />
          </ProtectedRoute>
        } />
        <Route path="/admin/view-expense-voucher/:id" element={
          <ProtectedRoute permission="can_create_expense_voucher">
            <EditExpenseVoucher />
          </ProtectedRoute>
        } />

        {/* Expense voucher approval chain — the executive director's settings page */}
        <Route path="/admin/voucher-settings" element={
          <ProtectedRoute permission="can_manage_voucher_settings">
            <VoucherSettings />
          </ProtectedRoute>
        } />

        {/* Manifests */}
        <Route path="/admin/manifest" element={
          <ProtectedRoute permission={['can_manage_manifest', 'role:fleet']}>
            <Manifest />
          </ProtectedRoute>
        } />
        <Route path="/admin/runway-manifest" element={
          <ProtectedRoute permission={['can_manage_runway_manifest', 'role:rider', 'role:driver', 'role:fleet']}>
            <RunwayManifest />
          </ProtectedRoute>
        } />

        {/* Tracking & Calculate Rate — open to all staff */}
        <Route path="/admin/tracking" element={
          <ProtectedRoute permission="authenticated">
            <AdminTracking />
          </ProtectedRoute>
        } />
        <Route path="/admin/calculate-rate" element={
          <ProtectedRoute permission="authenticated">
            <CalculateAdminRate />
          </ProtectedRoute>
        } />

        {/* Fleet Management */}
        <Route path="/admin/manage-riders" element={
          <ProtectedRoute permission={['can_manage_fleet', 'role:fleet']}>
            <ManageRider />
          </ProtectedRoute>
        } />

        {/* Branch */}
        <Route path="/admin/manage-branch" element={
          <ProtectedRoute permission="can_manage_branch">
            <ManageBranch />
          </ProtectedRoute>
        } />

        {/* Audits */}
        <Route path="/admin/audits" element={
          <ProtectedRoute permission="can_view_audit">
            <ManageAudit />
          </ProtectedRoute>
        } />

        {/* Staffs */}
        <Route path="/admin/manage-staffs" element={
          <ProtectedRoute permission="can_manage_staffs">
            <ManageStaffs />
          </ProtectedRoute>
        } />

        {/* Invoice & Expenses */}
        <Route path="/admin/manage-invoice" element={
          <ProtectedRoute permission="can_manage_invoice">
            <ManageInvoice />
          </ProtectedRoute>
        } />
        <Route path="/admin/manage-expense" element={
          <ProtectedRoute permission="can_manage_invoice">
            <ManageExpense />
          </ProtectedRoute>
        } />

        {/* Rates */}
        <Route path="/admin/manage-rates" element={
          <ProtectedRoute permission="can_manage_rates">
            <ManageRates />
          </ProtectedRoute>
        } />

        {/* Rider Applications */}
        <Route path="/admin/rider-applications" element={
          <ProtectedRoute permission="can_manage_riders_application">
            <RiderApplications />
          </ProtectedRoute>
        } />

        {/* Payment Confirmation */}
        <Route path="/admin/payment-confirmation" element={
          <ProtectedRoute permission="can_confirm_payment">
            <PaymentConfirmation />
          </ProtectedRoute>
        } />

        {/* Payment Approval */}
        <Route path="/admin/payment-approval" element={
          <ProtectedRoute permission="can_approve_payment">
            <PaymentApproval />
          </ProtectedRoute>
        } />

        {/* Delivery Payments */}
        <Route path="/admin/delivery-payments" element={
          <ProtectedRoute permission="can_view_approved_payment">
            <DeliveryPayments />
          </ProtectedRoute>
        } />

        <Route path="/admin/reimbursements" element={
          <ProtectedRoute permission={['can_initiate_reimbursement', 'can_approve_reimbursement_l1', 'can_approve_reimbursement_l2']}>
            <Reimbursements />
          </ProtectedRoute>
        } />

        {/* Legacy Migration */}
        <Route path="/admin/legacy-migration" element={
          <ProtectedRoute permission="can_manage_legacy_migration">
            <LegacyMigration />
          </ProtectedRoute>
        } />

        {/* Withdrawals */}
        <Route path="/admin/withdrawals" element={
          <ProtectedRoute permission="can_view_riders_witdrawal">
            <AdminWithdrawals />
          </ProtectedRoute>
        } />

        {/* Wallets — listing + detail. View requires can_view_wallets; suspend requires can_manage_wallets (enforced backend-side too). */}
        <Route path="/admin/wallets" element={
          <ProtectedRoute permission="can_view_wallets">
            <AdminWallets />
          </ProtectedRoute>
        } />
        <Route path="/admin/wallets/:userId" element={
          <ProtectedRoute permission="can_view_wallets">
            <AdminWalletDetail />
          </ProtectedRoute>
        } />

        {/* Fine Settings */}
        <Route path="/admin/fine-settings" element={
          <ProtectedRoute permission="can_manage_fine_settings">
            <FineSettings />
          </ProtectedRoute>
        } />

        {/* Fraud Monitor */}
        <Route path="/admin/fraud-dashboard" element={
          <ProtectedRoute permission="can_view_fraud_monitor">
            <FraudDashboard />
          </ProtectedRoute>
        } />

        {/* Rider Loans */}
        <Route path="/admin/rider-loans" element={
          <ProtectedRoute permission="can_manage_rider_loans">
            <RiderLoans />
          </ProtectedRoute>
        } />
        <Route path="/admin/loan-wallet" element={
          <ProtectedRoute permission="can_manage_rider_loans">
            <LoanWallet />
          </ProtectedRoute>
        } />
        <Route path="/admin/custom-duty" element={
          <ProtectedRoute permission="can_manage_custom_duty">
            <CustomDutyPayments />
          </ProtectedRoute>
        } />

        {/* Corporate client billing (SHEIN et al.) — zone/rate config and
            date-range invoice generation. Same permission gates both pages;
            configuring the rates and generating the invoice are one job. */}
        {/* The inbound FFDX feed — downloads manifests raised at other stations. */}
        <Route path="/admin/ffdx-feed" element={
          <ProtectedRoute permission="can_manage_ffdx_feed">
            <FfdxFeedLog />
          </ProtectedRoute>
        } />
        <Route path="/admin/billing/zones" element={
          <ProtectedRoute permission="can_manage_billing">
            <BillingZoneSettings />
          </ProtectedRoute>
        } />
        <Route path="/admin/billing/invoices" element={
          <ProtectedRoute permission="can_manage_billing">
            <ClientInvoices />
          </ProtectedRoute>
        } />

        {/* Bank-transfer payment proofs. Submitting and confirming are separate
            permissions: confirming settles invoices and releases freight. */}
        <Route path="/admin/payment-proofs/submit" element={
          <ProtectedRoute permission="can_submit_payment_proof">
            <SubmitPaymentProof />
          </ProtectedRoute>
        } />
        <Route path="/admin/payment-proofs" element={
          <ProtectedRoute permission="can_confirm_payment_proof">
            <PaymentProofs />
          </ProtectedRoute>
        } />

        {/* Fleet Agent — My Riders */}
        <Route path="/fleet/my-riders" element={
          <ProtectedRoute permission="role:fleet">
            <FleetRiders />
          </ProtectedRoute>
        } />

        {/* ── Partner / customer API gateway ──────────────────────
            Carried over from the api-integration branch as-is. These
            admin routes are NOT yet wrapped in ProtectedRoute — the
            branch predates it. Worth gating before production. */}
        <Route path="/admin/api-gateway" element={<ApiGatewayDashboard />} />
        <Route path="/admin/api-gateway/partners" element={<PartnerManagement />} />
        <Route path="/admin/api-gateway/partners/:id" element={<PartnerDetails />} />
        <Route path="/admin/api-gateway/partners/:partnerId/billing" element={<PartnerBilling />} />
        <Route path="/admin/api-gateway/api-keys" element={<ApiKeyManagement />} />
        <Route path="/admin/api-gateway/analytics" element={<ApiGatewayAnalytics />} />
        <Route path="/admin/api-gateway/system" element={<SystemHealth />} />
        <Route path="/admin/api-gateway/portal-accounts" element={<PortalAccountManagement />} />
        <Route path="/admin/api-gateway/portal-accounts/:id" element={<PortalAccountDetails />} />
        <Route path="/admin/api-gateway/invoices" element={<InvoiceManagement />} />

        {/* Admin integration manual — gated, unlike the rest of api-gateway.
            Same permission as the sidebar entry, so the URL can't be reached by
            staff who shouldn't see internal admin endpoints. */}
        <Route path="/admin/api-documentation" element={
          <ProtectedRoute permission="can_view_admin_stat">
            <ApiGatewayManual />
          </ProtectedRoute>
        } />

        {/* Customer-facing API access + portal */}
        <Route path="/api-access/register" element={<ApiAccessRegister />} />
        <Route path="/api-access/login" element={<ApiAccessLogin />} />
        <Route path="/api-portal/dashboard" element={<PortalDashboard />} />
        <Route path="/api-portal/api-keys" element={<PortalApiKeys />} />
        <Route path="/api-portal/usage" element={<PortalUsage />} />
        <Route path="/api-portal/wallet" element={<PortalWallet />} />
        <Route path="/api-portal/invoices" element={<PortalInvoices />} />
        <Route path="/api-portal/webhooks" element={<PortalWebhooks />} />
        <Route path="/api-portal/docs" element={<PortalDocs />} />
        <Route path="/api-portal/settings" element={<PortalSettings />} />
        <Route path="/api-portal/pending" element={<PortalPending />} />
        <Route path="/api-portal/rejected" element={<PortalRejected />} />
      </Routes>
    </div>
  );
}

export default App;